<template>
  <input class="modern-input"
         :value="value"
         @keydown.enter="$emit('enter')"
         @input="$emit('input', $event.target.value)">
</template>

<script>
export default {
  name: 'ModernInput',
  props: {
    value: null,
  },
};
</script>

<style scoped lang="stylus">

</style>
